// extracted by mini-css-extract-plugin
export default {"container":"hf910","placeInfoContainer":"AlMZk","ticketInfoContainer":"OSbLR","ticketName":"zoaDe"};